<template>
  <div class="tab-content betting-history betting-history-dark min-w1600" @click="partnerTreeOpen = false">
    <div class="page-title-line">
      베팅 내역 <span>›</span> {{ gameCategoryName }} 베팅내역
    </div>

    <div class="searchwrap">
      <div class="searchBar">
        <div class="box-ui-select searchbar-content">
          <div class="title"><span>날짜</span></div>
          <div class="fx date-controls">
            <div class="date-input-wrap">
              <input
                type="datetime-local"
                :value="dateTimeLocal(mainTableDate.startDate)"
                @change="setStartDateTime"
              />
              <span class="date-separator">~</span>
              <input
                type="datetime-local"
                :value="dateTimeLocal(mainTableDate.endDate)"
                @change="setEndDateTime"
              />
            </div>
            <button type="button" class="quick-btn active" @click="setQuickDate('today')">오늘</button>
            <button type="button" class="quick-btn" @click="setQuickDate('prevWeek')">이번 주</button>
            <button type="button" class="quick-btn" @click="setQuickDate('lastWeek')">지난 주</button>
            <button type="button" class="quick-btn" @click="setQuickDate('thisMonth')">이번 달</button>
            <button type="button" class="quick-btn" @click="setQuickDate('lastMonth')">지난 달</button>
            <label class="ui-check-wrap inline-check">
              <input type="checkbox" :checked="reqData.oldYn === 'Y'" @change="setOldYn" />
              <span>이전 데이터 검색</span>
            </label>
            <label class="ui-check-wrap inline-check">
              <input type="checkbox" :checked="reqData.bottomAllYn === 'N'" @change="setBottomAllYn" />
              <span>직하부만 보기</span>
            </label>
          </div>
        </div>
      </div>

      <div class="searchBar">
        <div class="box-ui-select searchbar-content">
          <div class="title"><span>카테고리</span></div>
          <div class="filter-row">
            <select class="mr-5" v-model="searchType">
              <option value="searchMemId">회원아이디</option>
              <option value="searchMemNick">회원닉네임</option>
              <option value="targetRecommenderId">상위/파트너 아이디</option>
            </select>
            <input
              type="text"
              class="mr-5 search-input"
              v-model="searchKeyword"
              placeholder="검색어"
              @keyup.enter="pageSearch"
            />
            <input
              type="text"
              class="mr-5 bet-id-input"
              v-model="reqData.betId"
              placeholder="베팅아이디"
              @keyup.enter="pageSearch"
            />
            <input
              type="number"
              class="mr-5 amount-input"
              v-model="reqData.winAmount"
              placeholder="당첨금액"
              @keyup.enter="pageSearch"
            />
            <select class="mr-5 count-select" v-model="reqData.count_per_list">
              <option :value="40">40 건</option>
              <option :value="100">100 건</option>
              <option :value="200">200 건</option>
              <option :value="300">300 건</option>
              <option :value="500">500 건</option>
            </select>
            <div class="partner-select-wrap" @click.stop>
              <button type="button" class="partner-select" @click="partnerTreeOpen = !partnerTreeOpen">
                하부 파트너 선택
              </button>
              <div class="partner-tree-dropdown" v-if="partnerTreeOpen">
                <PartnerHierarchy @onClickMemId="onClickPartnerTree" />
              </div>
            </div>
            <button class="btn-search" type="button" @click="pageSearch">
              검색
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <button type="button" class="memo-button" title="메모" disabled>
        <span></span>
      </button>
    </div>

    <div class="main-contents-wrapper">
      <div class="tab-wrap">
        <button type="button" class="tab-item" :class="{ active: reqData.gameCategory === '' }" @click="setGameCategory('')">전체</button>
        <button type="button" class="tab-item" :class="{ active: reqData.gameCategory === 'casino' }" @click="setGameCategory('casino')">카지노</button>
        <button type="button" class="tab-item" :class="{ active: reqData.gameCategory === 'slot' }" @click="setGameCategory('slot')">슬롯</button>
      </div>

      <div class="table-wrapper">
        <table class="mainTable">
          <colgroup>
            <col style="width: 3%" />
            <col style="width: 6%" />
            <col style="width: 6%" />
            <col style="width: 8%" />
            <col style="width: 10%" />
            <col style="width: 9%" />
            <col style="width: 10%" />
            <col style="width: 10%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 5%" />
          </colgroup>
          <thead>
            <tr>
              <th>번호</th>
              <th>아이디</th>
              <th>게임구분</th>
              <th>게임종류</th>
              <th>게임명</th>
              <th>베팅 ID</th>
              <th>베팅시각</th>
              <th>이전 보유금</th>
              <th>베팅금</th>
              <th>당첨금</th>
              <th>손익</th>
              <th>처리 후</th>
              <th>상태</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="bettingList.length > 0">
              <tr v-for="(item, idx) in bettingList" :key="item.betIdx || item.betId || item.regDate || idx">
                <td class="roboto">{{ rowNumber(item, idx) }}</td>
                <td>
                  <div class="fx-center-col gap-3">
                    <button type="button" class="fc-id btn-link" @click.stop="setMemberSearch(item.memId)">
                      {{ item.memId || '-' }}
                    </button>
                  </div>
                </td>
                <td><span class="game-kind">{{ item.gameCategory || gameCategoryName }}</span></td>
                <td>{{ item.vendorName || vendorName(item.vendorCode) }}</td>
                <td class="game-name">{{ item.gameName || '-' }}</td>
                <td class="w15">
                  <div class="btnWrap">
                    <button type="button" class="fc-btid btn-link" @click.stop="betDetailOpen(item)">
                      {{ item.betId || '-' }}
                    </button>
                    <button v-if="item.betId" type="button" class="copybtn" title="복사" @click.stop="copyToClipboard(item.betId)"></button>
                  </div>
                </td>
                <td class="roboto date-cell">{{ formatDate(item.regDate) }}</td>
                <td class="roboto">{{ thousand(rowBeforeBalance(item)) }}</td>
                <td class="roboto">{{ thousand(rowBetAmount(item)) }}</td>
                <td class="roboto">{{ thousand(rowWinAmount(item)) }}</td>
                <td class="roboto" :class="profitClass(rowProfit(item))">{{ thousand(rowProfit(item)) }}</td>
                <td class="roboto">{{ thousand(rowAfterBalance(item)) }}</td>
                <td :class="item.isBlankSpinYn === 'Y' ? 'e-bet' : 'e-bet-off'">
                  <span class="emptybet" :class="statusClass(item)">{{ rowStatus(item) }}</span>
                </td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="13" class="empty-cell">데이터가 없습니다.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <pagination
      v-if="pageInfo"
      :pageNum="pageInfo.page || pageInfo.pageNum || 1"
      :pageSize="pageInfo.count_per_list || pageInfo.pageSize || reqData.count_per_list || 100"
      :totalCount="pageInfo.tatal_list_count || pageInfo.total_list_count || pageInfo.totalCount || 0"
      :className="'partnerPaging'"
      @goToPage="loadData"
    />

    <div class="modal-wrapper" v-if="isDetailOpen" @click="betDetailClose"></div>
    <div class="modal-wrap" v-if="isDetailOpen">
      <article>
        <div class="sub-title">
          <h2>베팅 상세 내역</h2>
          <button class="btn" type="button" @click="betDetailClose">
            <img src="@/assets/img/icon_cancel.svg" alt="닫기" />
          </button>
        </div>
        <div class="page-content">
          <div class="content" v-if="betDetail">
            <div v-if="detailRoot && betDetail.detail.detail && betDetail.detail.detail.url">
              <iframe :src="detailRoot().url" style="width:100%; height: 80vh"></iframe>
            </div>
            <div v-else-if="!betDetail.detail || Object.keys(betDetail.detail).length === 0">
              상세내역 없음.
            </div>
            <div v-else>
              <div class="resultWrap">
                <h4>베팅정보</h4>
                <table style="text-align: center; margin-top: 20px;">
                  <tr>
                    <th>UID</th>
                    <th>베팅대상</th>
                    <th>게임결과</th>
                    <th>{{ $t('front.board.betMoney') }}</th>
                    <th>당첨금액</th>
                    <th>베팅시간</th>
                  </tr>
                  <template v-if="detailRoot().participants">
                    <template v-for="bet in detailRoot().participants[0].bets" v-bind:key="bet">
                      <tr>
                        <td>{{ bet.transactionId }}</td>
                        <td>{{ bet.code }}</td>
                        <td>{{ detailRoot().result.outcome }}</td>
                        <td>{{ thousand(bet.stake) }}</td>
                        <td>{{ thousand(bet.payout) }}</td>
                        <td>{{ dateFormatAll(bet.placedOn) }}</td>
                      </tr>
                    </template>
                  </template>
                </table>
              </div>

              <div class="resultWrap">
                <h4>게임 상세</h4>
                  <template v-for="betx in detailRoot().participants[0].bets" v-bind:key="betx">
                  <table>
                    <tr>
                      <th>회원정보</th>
                      <td>{{ memId }}</td>
                    </tr>
                    <tr>
                      <th>게임타입</th>
                      <td>{{ detailValue('gameProvider') || detailRoot().info.vendorName }}</td>
                    </tr>
                    <tr>
                      <th>베팅금 </th>
                      <td>{{ thousand(betx.stake) }}</td>
                    </tr>
                    <tr>
                      <th>당첨금</th>
                      <td>{{ thousand(betx.payout) }}</td>
                    </tr>
                    <tr>
                      <th>베팅시각</th>
                      <td>{{ betx.placedOn }}</td>
                    </tr>
                    <tr>
                      <th>베팅 위치</th>
                      <td>{{ betx.code }}</td>
                    </tr>
                    <tr>
                      <th>트랜잭션 아이디</th>
                      <td>{{ betx.transactionId }}</td>
                    </tr>
                  </table>
                    <br>
                </template>
              </div>
              <template v-if="dType === 'detail_3'">
                <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>
                  <template v-if="detailRoot().gameType === 'blackjack'">
                    <div class="result-box-wrap2">
                      <div>
                        <template v-for="([seatName, seatData], index) in Object.entries(betDetail.detail.detail.result.seats)" v-bind:key="index">
                          <p class="score scoreL">{{ seatName }} <span class="scoreN">{{ seatData.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in seatData.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.dealer.score }}</span> Dealer</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.dealer.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'baccarat'">
                    <div class="result-box-wrap2">
                      <div>
                        <p class="score scoreL">Player score <span class="scoreN">{{ detailRoot().result.player.score }}</span></p>
                        <div class="result_c">
                          <template v-for="prcard in betDetail.detail.detail.result.player.cards" :key="prcard">
                            <span :class="['cards', 'c' + prcard]"></span>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.banker.score }}</span> Banker score</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.banker.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                  </template>
                </div>
                <table>
                  <tr>
                    <th>회원정보</th>
                    <td>{{ memId }}</td>
                  </tr>
                  <tr>
                    <th>게임사</th>
                    <td>{{ detailRoot().gameProvider }}</td>
                  </tr>
                  <tr>
                    <th>게임ID, 플레이어ID</th>
                    <td>{{ detailRoot().id }}</td>
                  </tr>
                  <tr>
                    <th>시작시간</th>
                    <td>{{ detailRoot().settledAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>마감시간</th>
                    <td>{{ detailRoot().startedAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>상태</th>
                    <td>
                      <template v-if="detailRoot().status === 'Resolved'">
                        완료
                      </template>
                      <template v-else>
                        {{ detailRoot().status }}
                      </template>
                    </td>
                  </tr>
                </table>

              </template>
              <template v-else-if="dType === 'detail_4'">
                <!-- <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>
                  <template v-if="detailRoot[0].detail.gameType === 'blackjack'">
                    <div class="result-box-wrap">
                      <template v-for="([seatName, seatData], index) in Object.entries(betDetail.detail[0].detail.result.seats)" :key="index">
                        <div class="result-box">
                          <p class="score">{{ seatName }} <span class="scoreN">{{ seatData.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in seatData.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </div>
                      </template>
                      <div class="result-box">
                        <p class="score">Dealer <span class="scoreN">{{ betDetail.detail[0].detail.result.dealer.score }}</span></p>
                        <div class="result_c">
                          <template v-for="bdcard in betDetail.detail[0].detail.result.dealer.cards" :key="bdcard">
                            <span :class="['cards', 'c' + bdcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot[0].detail.gameType === 'powerscalableblackjack' || betDetail.detail[0].detail.gameType === 'lightningscalablebj'">
                    <div class="result-box-wrap">
                      <template v-for="hand in betDetail.detail[0].detail.participants[0].hands" :key="hand">
                        <div class="result-box">
                          <p class="score">User <span class="scoreN">{{ hand.score }}</span></p>
                          <div class="result_c">
                            <template v-for="ucard in betDetail.detail[0].detail.participants[0].hands.hand1.cards" :key="ucard">
                              <span :class="['cards', 'c' + ucard]"></span>
                            </template>
                          </div>
                        </div>
                      </template>
                      <div class="result-box" v-if="detailRoot[0].detail.result.dealerHand">
                        <p class="score">Dealer <span class="scoreN">{{ betDetail.detail[0].detail.result.dealerHand.score }}</span></p>
                        <div class="result_c">
                          <template v-for="dcard in betDetail.detail[0].detail.result.dealerHand.cards" :key="dcard">
                            <span :class="['cards', 'c' + dcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot[0].detail.gameType === 'baccarat'">
                    <div class="result-box-wrap2">
                      <div>
                        <p class="score scoreL">Player score <span class="scoreN">{{ betDetail.detail[0].detail.result.player.score }}</span></p>
                        <div class="result_c">
                          <template v-for="prcard in betDetail.detail[0].detail.result.player.cards" :key="prcard">
                            <span :class="['cards', 'c' + prcard]"></span>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ betDetail.detail[0].detail.result.banker.score }}</span> Banker score</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail[0].detail.result.banker.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                  </template>
                </div> -->
                <!-- <table>
                  <tr>
                    <th>회원정보</th>
                    <td>{{ memId }}</td>
                  </tr>
                  <tr>
                    <th>게임사</th>
                    <td>{{ betDetail.detail[0].detail.gameProvider }}</td>
                  </tr>
                  <tr>
                    <th>딜러명</th>
                    <td>{{ betDetail.detail[0].detail.dealer.name }}</td>
                  </tr>
                  <tr>
                    <th>테이블명</th>
                    <td>{{ betDetail.detail[0].detail.table.name }}</td>
                  </tr>
                  <tr>
                    <th>게임ID, 플레이어ID</th>
                    <td>{{ betDetail.detail[0].detail.id }}</td>
                  </tr>
                  <tr>
                    <th>시작시간</th>
                    <td>{{ betDetail.detail[0].detail.startedAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>마감시간</th>
                    <td>{{ betDetail.detail[0].detail.settledAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>상태</th>
                    <td>
                      <template v-if="detailRoot[0].detail.status === 'Resolved'">
                        완료
                      </template>
                      <template v-else>
                        {{ betDetail.detail[0].detail.status }}
                      </template>
                    </td>
                  </tr>
                </table> -->
              </template>
              <template v-else-if="dType === 'detail_5'">
                <!-- <pre>{{ detailRoot().data }}</pre> -->
                <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>
                  <template v-if="detailRoot().data.gameType === 'topcard'">
                    <div class="result-box-wrap">
                      <div class="result-box">
                        <p class="score">Aspot score <span class="scoreN">{{ detailRoot().data.result.aSpot.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.detail.data.result.aSpot.card]"></span>
                        </div>
                      </div>
                      <div class="result-box">
                        <p class="score">Bspot score <span class="scoreN">{{ detailRoot().data.result.bSpot.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.detail.data.result.bSpot.card]"></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().data.gameType === 'dragontiger'">
                    <div class="result-box-wrap">
                      <div class="result-box">
                        <p class="score">Tiger score <span class="scoreN">{{ detailRoot().data.result.tiger.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.detail.data.result.tiger.card]"></span>
                        </div>
                      </div>
                      <div class="result-box">
                        <p class="score">Dragon score <span class="scoreN">{{ detailRoot().data.result.dragon.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.detail.data.result.dragon.card]"></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().data.gameType === 'rng-blackjack' || betDetail.detail.detail.detail.data.gameType === 'blackjack'">
                    <div class="result-box-wrap2">
                      <div>
                        <template v-for="([seatName, seatData], index) in Object.entries(betDetail.detail.detail.detail.data.result.seats)" v-bind:key="index">
                          <p class="score scoreL">{{ seatName }} <span class="scoreN">{{ seatData.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in seatData.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().data.result.dealer.score }}</span> Dealer</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.detail.data.result.dealer.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().data.gameType === 'rng-baccarat' || betDetail.detail.detail.detail.data.gameType === 'baccarat'">
                    <div class="result-box-wrap2">
                      <div>
                        <p class="score scoreL">Player score <span class="scoreN">{{ detailRoot().data.result.player.score }}</span></p>
                        <div class="result_c">
                          <template v-for="prcard in betDetail.detail.detail.detail.data.result.player.cards" :key="prcard">
                            <span :class="['cards', 'c' + prcard]"></span>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().data.result.banker.score }}</span> Banker score</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.detail.data.result.banker.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                  </template>
                </div>
                <table>
                  <tr>
                    <th>회원정보</th>
                    <td>{{ memId }}</td>
                  </tr>
                  <tr>
                    <th>게임사</th>
                    <td>{{ detailRoot().data.gameProvider }}</td>
                  </tr>
                  <tr>
                    <th>게임ID, 플레이어ID</th>
                    <td>{{ detailRoot().data.id }}</td>
                  </tr>
                  <tr>
                    <th>시작시간</th>
                    <td>{{ detailRoot().data.settledAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>마감시간</th>
                    <td>{{ detailRoot().data.startedAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>상태</th>
                    <td>
                      <template v-if="detailRoot().data.status === 'Resolved'">
                        완료
                      </template>
                      <template v-else>
                        {{ detailRoot().data.status }}
                      </template>
                    </td>
                  </tr>
                </table>
              </template>
              <template v-else-if="dType === 'detail_8'">
                <!-- <pre>{{ detailRoot().detail }}</pre> -->
                <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>
                  <template v-if="detailRoot().gameType === 'dragontiger'">
                    <div class="result-box-wrap">
                      <div class="result-box">
                        <p class="score">Tiger score <span class="scoreN">{{ detailRoot().result.tiger.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.tiger.card]"></span>
                        </div>
                      </div>
                      <div class="result-box">
                        <p class="score">Dragon score <span class="scoreN">{{ detailRoot().result.dragon.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.dragon.card]"></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'rng-blackjack' || betDetail.detail.detail.gameType === 'blackjack'">
                    <div class="result-box-wrap2">
                      <div>
                        <template v-for="([seatName, seatData], index) in Object.entries(betDetail.detail.detail.result.seats)" v-bind:key="index">
                          <p class="score scoreL">{{ seatName }} <span class="scoreN">{{ seatData.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in seatData.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.dealer.score }}</span> Dealer</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.dealer.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'rng-baccarat' || betDetail.detail.detail.gameType === 'baccarat'">
                    <div class="result-box-wrap2">
                      <div>
                        <p class="score scoreL">Player score <span class="scoreN">{{ detailRoot().result.player.score }}</span></p>
                        <div class="result_c">
                          <template v-for="prcard in betDetail.detail.detail.result.player.cards" :key="prcard">
                            <span :class="['cards', 'c' + prcard]"></span>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.banker.score }}</span> Banker score</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.banker.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                  </template>
                </div>
                <table>
                  <tr>
                    <th>회원정보</th>
                    <td>{{ memId }}</td>
                  </tr>
                  <tr>
                    <th>게임사</th>
                    <td>{{ detailRoot().gameProvider }}</td>
                  </tr>
                  <tr>
                    <th>게임ID, 플레이어ID</th>
                    <td>{{ detailRoot().id }}</td>
                  </tr>
                  <tr>
                    <th>시작시간</th>
                    <td>{{ detailRoot().settledAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>마감시간</th>
                    <td>{{ detailRoot().startedAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>상태</th>
                    <td>
                      <template v-if="detailRoot().status === 'Resolved'">
                        완료
                      </template>
                      <template v-else>
                        {{ detailRoot().status }}
                      </template>
                    </td>
                  </tr>
                </table>
              </template>
              <template v-else-if="dType === 'detail_9'">
                <!-- <pre>{{ detailRoot().detail }}</pre> -->
                <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>

                  <template v-if="detailRoot().result">
                    <div class="result-box-wrap2">
                      <template v-if="detailRoot().result.player">
                        <div>
                          <p class="score scoreL">Player score <span class="scoreN">{{ detailRoot().result.player.score }}</span></p>
                          <div class="result_c">
                            <template v-for="prcard in betDetail.detail.detail.result.player.cards" :key="prcard">
                              <span :class="['cards', 'c' + prcard]"></span>
                            </template>
                          </div>
                        </div>
                      </template>
                      <template v-if="detailRoot().result.banker">
                        <div>
                          <p class="score"><span class="scoreN">{{ detailRoot().result.banker.score }}</span> Banker score</p>
                          <div class="result_c">
                            <template v-for="bkcard in betDetail.detail.detail.result.banker.cards" :key="bkcard">
                              <span :class="['cards', 'c' + bkcard]"></span>
                            </template>
                          </div>
                        </div>
                      </template>
                      <template v-if="detailRoot().result.tiger">
                        <div class="result-box">
                          <p class="score">Tiger score <span class="scoreN">{{ detailRoot().result.tiger.score }}</span></p>
                          <div class="result_c">
                            <span :class="['cards', 'c' + betDetail.detail.detail.result.tiger.card]"></span>
                          </div>
                        </div>
                      </template>
                      <template v-if="detailRoot().result.dragon">
                        <div class="result-box">
                          <p class="score">Dragon score <span class="scoreN">{{ detailRoot().result.dragon.score }}</span></p>
                          <div class="result_c">
                            <span :class="['cards', 'c' + betDetail.detail.detail.result.dragon.card]"></span>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().data">

                    <div class="result-box-wrap2" v-if="detailRoot().data.gameType === 'blackjack'">
                      <div>
                        <template v-for="bjcard in detailRoot().data.result.user" v-bind:key="bjcard">
                          <p class="score scoreL">{{ bjcard.sheet }} <span class="scoreN">{{ bjcard.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in bjcard.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN"></span> Dealer</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.data.data.result.dealer" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else></template>
                </div>
                <template v-if="detailRoot().bets">
                  <template v-for="betx in betDetail.detail.detail.bets" v-bind:key="betx">
                    <table>
                      <tr>
                        <th>회원정보</th>
                        <td>{{ memId }}</td>
                      </tr>
                      <tr>
                        <th>베팅금액</th>
                        <td>{{ betx.stake }}</td>
                      </tr>
                      <tr>
                        <th>당첨금액</th>
                        <td>{{ betx.payout }}</td>
                      </tr>
                      <tr>
                        <th>베팅시각</th>
                        <td>{{ betx.placedOn }}</td>
                      </tr>
                      <tr>
                        <th>베팅위치</th>
                        <td>{{ betx.code }}</td>
                      </tr>
                      <tr>
                        <th>트랜젝션아이디</th>
                        <td>{{ betx.transactionId }}</td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template v-else-if="detailRoot().data">
                  <template v-for="bets in betDetail.detail.detail.data.data.bets" v-bind:key="bets">
                    <table>
                      <tr>
                        <th>게임타입</th>
                        <td>{{ detailRoot().data.game_type_code }}</td>
                      </tr>
                      <tr>
                        <th>베팅금액</th>
                        <td>{{ bets.betAmount }}</td>
                      </tr>
                      <tr>
                        <th>당첨금액</th>
                        <td>{{ bets.winAmount }}</td>
                      </tr>
                      <tr>
                        <th>베팅시각</th>
                        <td>{{ detailRoot().data.created_at }}</td>
                      </tr>
                      <tr>
                        <th>베팅위치</th>
                        <td>{{ bets.target }}</td>
                      </tr>
                      <tr>
                        <th>트랜젝션아이디</th>
                        <td>{{ detailRoot().data.id }}</td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template v-else></template>
              </template>
              <template v-else-if="dType === 'detail_10'">
                <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>
                  <template v-if="detailRoot().gameType === 'topcard'">
                    <div class="result-box-wrap">
                      <div class="result-box">
                        <p class="score">Aspot score <span class="scoreN">{{ detailRoot().result.aSpot.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.aSpot.card]"></span>
                        </div>
                      </div>
                      <div class="result-box">
                        <p class="score">Bspot score <span class="scoreN">{{ detailRoot().result.bSpot.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.bSpot.card]"></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'dragontiger'">
                    <div class="result-box-wrap">
                      <div class="result-box">
                        <p class="score">Tiger score <span class="scoreN">{{ detailRoot().result.tiger.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.tiger.card]"></span>
                        </div>
                      </div>
                      <div class="result-box">
                        <p class="score">Dragon score <span class="scoreN">{{ detailRoot().result.dragon.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.dragon.card]"></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'rng-blackjack' || betDetail.detail.detail.gameType === 'blackjack'">
                    <div class="result-box-wrap2">
                      <div>
                        <template v-for="([seatName, seatData], index) in Object.entries(betDetail.detail.detail.result.seats)" v-bind:key="index">
                          <p class="score scoreL">{{ seatName }} <span class="scoreN">{{ seatData.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in seatData.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.dealer.score }}</span> Dealer</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.dealer.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'rng-baccarat' || betDetail.detail.detail.gameType === 'baccarat'">
                    <div class="result-box-wrap2">
                      <div>
                        <p class="score scoreL">Player score <span class="scoreN">{{ detailRoot().result.player.score }}</span></p>
                        <div class="result_c">
                          <template v-for="prcard in betDetail.detail.detail.result.player.cards" :key="prcard">
                            <span :class="['cards', 'c' + prcard]"></span>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.banker.score }}</span> Banker score</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.banker.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                  </template>
                </div>
                <template v-if="detailRoot().bets">
                  <template v-for="betx in betDetail.detail.detail.bets" v-bind:key="betx">
                    <table>
                      <tr>
                        <th>회원정보</th>
                        <td>{{ memId }}</td>
                      </tr>
                      <tr>
                        <th>베팅금액</th>
                        <td>{{ betx.stake }}</td>
                      </tr>
                      <tr>
                        <th>당첨금액</th>
                        <td>{{ betx.payout }}</td>
                      </tr>
                      <tr>
                        <th>베팅시각</th>
                        <td>{{ betx.placedOn }}</td>
                      </tr>
                      <tr>
                        <th>베팅위치</th>
                        <td>{{ betx.code }}</td>
                      </tr>
                      <tr>
                        <th>트랜젝션아이디</th>
                        <td>{{ betx.transactionId }}</td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template v-else-if="detailRoot().data">
                  <template v-for="bets in betDetail.detail.detail.data.data.bets" v-bind:key="bets">
                    <table>
                      <tr>
                        <th>게임타입</th>
                        <td>{{ detailRoot().data.game_type_code }}</td>
                      </tr>
                      <tr>
                        <th>베팅금액</th>
                        <td>{{ bets.betAmount }}</td>
                      </tr>
                      <tr>
                        <th>당첨금액</th>
                        <td>{{ bets.winAmount }}</td>
                      </tr>
                      <tr>
                        <th>베팅시각</th>
                        <td>{{ detailRoot().data.created_at }}</td>
                      </tr>
                      <tr>
                        <th>베팅위치</th>
                        <td>{{ bets.target }}</td>
                      </tr>
                      <tr>
                        <th>트랜젝션아이디</th>
                        <td>{{ detailRoot().data.id }}</td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template v-else></template>
              </template>
              <template v-else-if="dType === 'detail_11'">
                <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>
                  <template v-if="detailRoot().gameType === 'topcard'">
                    <div class="result-box-wrap">
                      <div class="result-box">
                        <p class="score">Aspot score <span class="scoreN">{{ detailRoot().result.aSpot.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.aSpot.card]"></span>
                        </div>
                      </div>
                      <div class="result-box">
                        <p class="score">Bspot score <span class="scoreN">{{ detailRoot().result.bSpot.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.bSpot.card]"></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'dragontiger'">
                    <div class="result-box-wrap">
                      <div class="result-box">
                        <p class="score">Tiger score <span class="scoreN">{{ detailRoot().result.tiger.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.tiger.card]"></span>
                        </div>
                      </div>
                      <div class="result-box">
                        <p class="score">Dragon score <span class="scoreN">{{ detailRoot().result.dragon.score }}</span></p>
                        <div class="result_c">
                          <span :class="['cards', 'c' + betDetail.detail.detail.result.dragon.card]"></span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'rng-blackjack' || betDetail.detail.detail.gameType === 'blackjack'">
                    <div class="result-box-wrap2">
                      <div>
                        <template v-for="([seatName, seatData], index) in Object.entries(betDetail.detail.detail.result.seats)" v-bind:key="index">
                          <p class="score scoreL">{{ seatName }} <span class="scoreN">{{ seatData.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in seatData.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </template>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.dealer.score }}</span> Dealer</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.dealer.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot().gameType === 'rng-baccarat' || betDetail.detail.detail.gameType === 'baccarat'">
                    <div class="result-box-wrap2">
                      <div>
                        <p class="score scoreL">Player score <span class="scoreN">{{ detailRoot().result.player.score }}</span></p>
                        <div class="result_c">
                          <template v-for="prcard in betDetail.detail.detail.result.player.cards" :key="prcard">
                            <span :class="['cards', 'c' + prcard]"></span>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ detailRoot().result.banker.score }}</span> Banker score</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail.detail.result.banker.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                  </template>
                </div>
                <template v-if="detailRoot().bets">
                  <template v-for="betx in betDetail.detail.detail.bets" v-bind:key="betx">
                    <table>
                      <tr>
                        <th>회원정보</th>
                        <td>{{ memId }}</td>
                      </tr>
                      <tr>
                        <th>베팅금액</th>
                        <td>{{ betx.stake }}</td>
                      </tr>
                      <tr>
                        <th>당첨금액</th>
                        <td>{{ betx.payout }}</td>
                      </tr>
                      <tr>
                        <th>베팅시각</th>
                        <td>{{ betx.placedOn }}</td>
                      </tr>
                      <tr>
                        <th>베팅위치</th>
                        <td>{{ betx.code }}</td>
                      </tr>
                      <tr>
                        <th>트랜젝션아이디</th>
                        <td>{{ betx.transactionId }}</td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template v-else-if="detailRoot().data">
                  <template v-for="bets in betDetail.detail.detail.data.data.bets" v-bind:key="bets">
                    <table>
                      <tr>
                        <th>게임타입</th>
                        <td>{{ detailRoot().data.game_type_code }}</td>
                      </tr>
                      <tr>
                        <th>베팅금액</th>
                        <td>{{ bets.betAmount }}</td>
                      </tr>
                      <tr>
                        <th>당첨금액</th>
                        <td>{{ bets.winAmount }}</td>
                      </tr>
                      <tr>
                        <th>베팅시각</th>
                        <td>{{ detailRoot().data.created_at }}</td>
                      </tr>
                      <tr>
                        <th>베팅위치</th>
                        <td>{{ bets.target }}</td>
                      </tr>
                      <tr>
                        <th>트랜젝션아이디</th>
                        <td>{{ detailRoot().data.id }}</td>
                      </tr>
                    </table>
                  </template>
                </template>
                <template v-else></template>
              </template>
              <template v-else>
                <div class="resultWrap">
                  <h4>베팅 및 게임결과</h4>
                  <template v-if="detailRoot[0].detail.gameType === 'blackjack'">
                    <div class="result-box-wrap">
                      <template v-for="([seatName, seatData], index) in Object.entries(betDetail.detail[0].detail.result.seats)" :key="index">
                        <div class="result-box">
                          <p class="score">{{ seatName }} <span class="scoreN">{{ seatData.score }}</span></p>
                          <div class="result_c">
                            <template v-for="bscard in seatData.cards" :key="bscard">
                              <span :class="['cards', 'c' + bscard]"></span>
                            </template>
                          </div>
                        </div>
                      </template>
                      <div class="result-box">
                        <p class="score">Dealer <span class="scoreN">{{ betDetail.detail[0].detail.result.dealer.score }}</span></p>
                        <div class="result_c">
                          <template v-for="bdcard in betDetail.detail[0].detail.result.dealer.cards" :key="bdcard">
                            <span :class="['cards', 'c' + bdcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot[0].detail.gameType === 'powerscalableblackjack' || betDetail.detail[0].detail.gameType === 'lightningscalablebj'">
                    <div class="result-box-wrap">
                      <template v-for="hand in betDetail.detail[0].detail.participants[0].hands" :key="hand">
                        <div class="result-box">
                          <p class="score">User <span class="scoreN">{{ hand.score }}</span></p>
                          <div class="result_c">
                            <template v-for="ucard in betDetail.detail[0].detail.participants[0].hands.hand1.cards" :key="ucard">
                              <span :class="['cards', 'c' + ucard]"></span>
                            </template>
                          </div>
                        </div>
                      </template>
                      <div class="result-box" v-if="detailRoot[0].detail.result.dealerHand">
                        <p class="score">Dealer <span class="scoreN">{{ betDetail.detail[0].detail.result.dealerHand.score }}</span></p>
                        <div class="result_c">
                          <template v-for="dcard in betDetail.detail[0].detail.result.dealerHand.cards" :key="dcard">
                            <span :class="['cards', 'c' + dcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="detailRoot[0].detail.gameType === 'baccarat'">
                    <div class="result-box-wrap2">
                      <div>
                        <p class="score scoreL">Player score <span class="scoreN">{{ betDetail.detail[0].detail.result.player.score }}</span></p>
                        <div class="result_c">
                          <template v-for="prcard in betDetail.detail[0].detail.result.player.cards" :key="prcard">
                            <span :class="['cards', 'c' + prcard]"></span>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="score"><span class="scoreN">{{ betDetail.detail[0].detail.result.banker.score }}</span> Banker score</p>
                        <div class="result_c">
                          <template v-for="bkcard in betDetail.detail[0].detail.result.banker.cards" :key="bkcard">
                            <span :class="['cards', 'c' + bkcard]"></span>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <!-- {{ betDetail.detail[0].detail.result }} -->
                  </template>
                </div>
                <table>
                  <tr>
                    <th>회원정보</th>
                    <td>{{ memId }}</td>
                  </tr>
                  <tr>
                    <th>게임사</th>
                    <td>{{ betDetail.detail[0].detail.gameProvider }}</td>
                  </tr>
                  <tr>
                    <th>딜러명</th>
                    <td>{{ betDetail.detail[0].detail.dealer.name }}</td>
                  </tr>
                  <tr>
                    <th>테이블명</th>
                    <td>{{ betDetail.detail[0].detail.table.name }}</td>
                  </tr>
                  <tr>
                    <th>게임ID, 플레이어ID</th>
                    <td>{{ betDetail.detail[0].detail.id }}</td>
                  </tr>
                  <tr>
                    <th>시작시간</th>
                    <td>{{ betDetail.detail[0].detail.startedAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>마감시간</th>
                    <td>{{ betDetail.detail[0].detail.settledAt }} ( UTC +9)</td>
                  </tr>
                  <tr>
                    <th>상태</th>
                    <td>
                      <template v-if="detailRoot[0].detail.status === 'Resolved'">
                        완료
                      </template>
                      <template v-else>
                        {{ betDetail.detail[0].detail.status }}
                      </template>
                    </td>
                  </tr>
                </table>
              </template>

              <!-- <pre class="detail-json">{{ betDetailStr }}</pre> -->
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/ui/Pagination.vue'
import PartnerHierarchy from '@/components/common/mobile/PartnerHierarchy.vue'
import { getDateStr, thousand } from '@/libs/utils'
import { addDays } from 'date-fns'
import { mapState } from 'vuex'
import { getBettingDetailV3, getPartnerBetList2V2 } from '@/api/v2/betting'
import { de } from 'date-fns/locale'

export default {
  name: 'PartnerCasinoBettingList',
  components: { Pagination, PartnerHierarchy },
  computed: {
    de () {
      return de
    },
    ...mapState([
      'userData',
      'commonCodeByOrder'
    ]),
    gameCategoryName () {
      if (this.reqData.gameCategory === 'slot') return '슬롯'
      if (this.reqData.gameCategory === 'casino') return '카지노'

      return '전체'
    }
  },
  data () {
    const startDate = getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 00:00:00')
    const endDate = getDateStr(addDays(new Date(), 0), 'yyyy-MM-dd 23:59:59')

    return {
      searchType: 'searchMemId',
      searchKeyword: '',
      mainTableDate: {
        startDate,
        endDate
      },
      reqData: {
        gameCategory: 'casino',
        targetRecommenderId: '',
        searchMemId: '',
        searchMemNick: '',
        betId: '',
        winAmount: 0,
        startDate: startDate,
        endDate: endDate,
        oldYn: 'N',
        bottomAllYn: 'Y',
        count_per_list: 100
      },
      bettingList: [],
      pageInfo: null,
      partnerTreeOpen: false,
      selectedPartner: null,
      isDetailOpen: false,
      betDetail: null,
      betDetailStr: '',
      dType: null,
      memId: null
    }
  },
  watch: {
    '$route.name' () {
      this.applyRouteGameCategory()
      this.loadData(1)
    }
  },
  async created () {
    this.applyRouteGameCategory()
    this.reqData.targetRecommenderId = this.userData.memId

    if (this.$route.query.id) {
      this.reqData.searchMemId = this.$route.query.id
      this.searchKeyword = this.$route.query.id
    }

    await this.loadData(1)
  },
  methods: {
    thousand,
    dateOnly (value) {
      return value ? value.split(' ')[0] : ''
    },
    dateTimeLocal (value) {
      if (!value) return ''

      return value.replace(' ', 'T').slice(0, 16)
    },
    setStartDate (event) {
      const date = event && event.target ? event.target.value : event
      this.mainTableDate.startDate = `${date} 00:00:00`
      this.reqData.startDate = getDateStr(new Date(this.mainTableDate.startDate), 'yyyy-MM-dd 00:00:00')
    },
    setEndDate (event) {
      const date = event && event.target ? event.target.value : event
      this.mainTableDate.endDate = `${date} 23:59:59`
      this.reqData.endDate = getDateStr(new Date(this.mainTableDate.endDate), 'yyyy-MM-dd 23:59:59')
    },
    setStartDateTime (event) {
      const value = event.target.value.replace('T', ' ')
      this.mainTableDate.startDate = `${value}:00`
      this.reqData.startDate = getDateStr(new Date(this.mainTableDate.startDate), 'yyyy-MM-dd HH:mm:ss')
    },
    setEndDateTime (event) {
      const value = event.target.value.replace('T', ' ')
      this.mainTableDate.endDate = `${value}:59`
      this.reqData.endDate = getDateStr(new Date(this.mainTableDate.endDate), 'yyyy-MM-dd HH:mm:ss')
    },
    setDateRange (start, end) {
      this.mainTableDate.startDate = getDateStr(start, 'yyyy-MM-dd HH:mm:ss')
      this.mainTableDate.endDate = getDateStr(end, 'yyyy-MM-dd HH:mm:ss')
      this.reqData.startDate = this.mainTableDate.startDate
      this.reqData.endDate = this.mainTableDate.endDate
    },
    setQuickDate (type) {
      const now = new Date()
      const start = new Date(now)
      const end = new Date(now)

      start.setHours(0, 0, 0, 0)
      end.setHours(23, 59, 59, 999)

      if (type === 'prevWeek') {
        start.setDate(now.getDate() - 7)
      }

      if (type === 'lastWeek') {
        const day = now.getDay() || 7
        start.setDate(now.getDate() - day - 6)
        end.setDate(now.getDate() - day)
      }

      if (type === 'thisMonth') {
        start.setDate(1)
      }

      if (type === 'lastMonth') {
        start.setDate(1)
        start.setMonth(now.getMonth() - 1)
        end.setDate(0)
      }

      this.setDateRange(start, end)
      this.loadData(1)
    },
    setOldYn (event) {
      this.reqData.oldYn = event.target.checked ? 'Y' : 'N'
    },
    setBottomAllYn (event) {
      this.reqData.bottomAllYn = event.target.checked ? 'N' : 'Y'
    },
    syncSearchKeyword () {
      this.reqData.searchMemId = ''
      this.reqData.searchMemNick = ''

      if (this.searchType === 'targetRecommenderId') {
        this.reqData.targetRecommenderId = this.searchKeyword || this.userData.memId
        return
      }

      if (!this.reqData.targetRecommenderId) {
        this.reqData.targetRecommenderId = this.userData.memId
      }

      this.reqData[this.searchType] = this.searchKeyword
    },
    pageSearch () {
      this.syncSearchKeyword()
      this.loadData(1)
    },
    setGameCategory (category) {
      this.reqData.gameCategory = category
      this.loadData(1)
    },
    setMemberSearch (memId) {
      this.searchType = 'searchMemId'
      this.searchKeyword = memId || ''
      this.pageSearch()
    },
    formatDate (value) {
      if (!value) return '-'

      if (typeof this.dateFormatAll === 'function') {
        return this.dateFormatAll(value)
      }

      return value
    },
    toNumber (value) {
      const number = Number(value || 0)

      return Number.isNaN(number) ? 0 : number
    },
    rowNumber (item, index) {
      const info = this.pageInfo || {}
      const total = info.tatal_list_count || info.total_list_count || info.totalCount || 0
      const page = info.page || info.pageNum || 1
      const limit = info.limit || info.count_per_list || info.pageSize || this.reqData.count_per_list || 100

      if (total) {
        return total - (limit * (page - 1)) - index
      }

      return item.betIdx || index + 1
    },
    rowBeforeBalance (item) {
      if (item.bfMoney !== undefined) return item.bfMoney
      if (item.bfBalance !== undefined) return item.bfBalance
      if (item.beforeBalance !== undefined) return item.beforeBalance

      return 0
    },
    rowBetAmount (item) {
      if (item.betAmt !== undefined) return item.betAmt
      if (item.betAmount !== undefined) return item.betAmount
      if (item.amount !== undefined) return item.amount

      return 0
    },
    rowWinAmount (item) {
      if (item.betWinAmt !== undefined) return item.betWinAmt
      if (item.winAmount !== undefined) return item.winAmount
      if (item.payout !== undefined) return item.payout

      return 0
    },
    rowAfterBalance (item) {
      if (item.afMoney !== undefined) return item.afMoney
      if (item.afBalance !== undefined) return item.afBalance
      if (item.afterBalance !== undefined) return item.afterBalance

      return 0
    },
    rowProfit (item) {
      if (item.revenue !== undefined || item.profit !== undefined) {
        return this.toNumber(item.revenue !== undefined ? item.revenue : item.profit)
      }

      if (item.betAmt !== undefined || item.betWinAmt !== undefined) {
        return this.toNumber(this.rowBetAmount(item)) - this.toNumber(this.rowWinAmount(item))
      }

      return this.toNumber(item.amount)
    },
    profitClass (amount) {
      const number = this.toNumber(amount)
      if (number > 0) return 'red-text'
      if (number < 0) return 'blue-text'

      return ''
    },
    rowStatus (item) {
      if (item.betType === 'C') return '취소'
      if (item.betType === 'B') return '보너스'
      if (item.betType === 'BET') return '베팅'
      if (item.betType === 'RES') return '완료'

      return item.tranTypeDesc || item.tranType || item.status || '-'
    },
    statusClass (item) {
      const status = this.rowStatus(item)

      return {
        resultbet: status === '완료' || status === '결과',
        'box-w': status === '대기' || status === '대기중',
        'box-l': status === '패배',
        'box-t': status === '무'
      }
    },
    copyToClipboard (text) {
      if (!text) return

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          alert('클립보드에 복사했습니다')
        })
        return
      }

      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      alert('클립보드에 복사했습니다')
    },
    onClickPartnerTree (memId, type, item) {
      this.selectedPartner = item
      this.reqData.targetRecommenderId = memId
      this.partnerTreeOpen = false
      this.loadData(1)
    },
    betDetailOpen (bet) {
      this.memId = bet.memId
      getBettingDetailV3({ betId: bet.betId }).then(res => {
        const result = res.data

        if (result.resultCode === '0') {
          let detailData = result.data.detail || {}
          if (typeof detailData === 'string') {
            detailData = JSON.parse(detailData)
          }

          this.betDetail = {
            detail: detailData,
            info: bet
          }
          this.dType = this.betDetail.detail.dType
          this.betDetailStr = JSON.stringify(this.betDetail, undefined, 2)
          this.isDetailOpen = true
        }
      })
    },
    betDetailClose () {
      this.isDetailOpen = false
    },
    detailRoot () {
      if (!this.betDetail || !this.betDetail.detail) {
        return null
      }

      if (this.betDetail.detail.detail && this.betDetail.detail.detail.detail && this.betDetail.detail.detail.detail.data) {
        return this.betDetail.detail.detail.detail.data
      }

      if (this.betDetail.detail.detail) {
        return this.betDetail.detail.detail
      }

      if (Array.isArray(this.betDetail.detail) && this.betDetail.detail[0] && this.betDetail.detail[0].detail) {
        return this.betDetail.detail[0].detail
      }

      return this.betDetail.detail
    },
    detailValue (key) {
      const detail = this.detailRoot()

      return detail ? detail[key] : null
    },
    detailPayout () {
      return this.detailValue('payout') || this.betDetail.info.afBalance || 0
    },
    applyRouteGameCategory () {
      this.reqData.gameCategory = this.$route.name === 'bettingDetailListSlot' ? 'slot' : 'casino'
    },
    vendorName (vendorCode) {
      const vendorList = this.commonCodeByOrder && this.commonCodeByOrder.casino
      const vendor = vendorList && Object.values(vendorList).find(item => item.code === vendorCode)

      return vendor ? vendor.codeName : '-'
    },
    amountClass (amount) {
      return {
        rdc: Number(amount) > 0,
        blc: Number(amount) < 0
      }
    },
    async loadData (page = 1) {
      this.emitter.emit('Loading', true)
      if (!this.reqData.targetRecommenderId) {
        this.reqData.targetRecommenderId = this.userData.memId
      }

      const params = {
        ...this.reqData,
        winAmount: Number(this.reqData.winAmount || 0),
        page,
        count_per_list: this.reqData.count_per_list || 100,
        orderColumn: 'regDate',
        orderType: 'DESC'
      }

      await getPartnerBetList2V2(params).then(res => {
        const data = res.data.data

        if (data) {
          this.bettingList = data.list || []
          this.pageInfo = data.pageInfo || null
        } else {
          this.bettingList = []
          this.pageInfo = null
        }
      }).finally(() => {
        this.emitter.emit('Loading', false)
      })
    }
  }
}
</script>

<style scoped src="@/styles/common.css"></style>
<style scoped src="@/styles/striNew.css"></style>

<style scoped>
.betting-history {
  min-height: calc(100vh - 40px);
  padding: 0 14px 40px;
  background: #0b1220;
  color: #dce6f3;
  font-size: 13px;
}

.min-w1600 {
  min-width: 1600px;
}

.page-title-line {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 46px;
  color: #dce6f3;
  font-size: 15px;
  font-weight: 800;
}

.page-title-line span {
  color: #7f8ca3;
}

.searchwrap {
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 8px;
  min-height: 104px;
  padding: 14px 76px 14px 12px;
  margin-bottom: 10px;
  background: #172233;
  border: 1px solid #233349;
}

.searchBar {
  display: flex;
  flex: 1 1 auto;
  min-width: 0;
}

.box-ui-select {
  width: 100%;
}

.searchbar-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.searchbar-content .title {
  display: flex;
  align-items: center;
  height: 18px;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
}

.fx,
.filter-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.date-input-wrap {
  display: flex;
  align-items: center;
  gap: 6px;
}

.date-separator {
  color: #dce6f3;
  font-weight: 800;
}

.betting-history input,
.betting-history select {
  height: 28px !important;
  min-width: 0 !important;
  padding: 0 10px !important;
  border: 1px solid #26364d !important;
  border-radius: 2px !important;
  background: #233044 !important;
  color: #dce6f3 !important;
  font-size: 12px !important;
  outline: none;
}

.betting-history input::placeholder {
  color: #8190a7;
}

.betting-history select {
  min-width: 96px !important;
}

.date-input-wrap input {
  width: 150px !important;
}

.search-input {
  width: 156px !important;
}

.bet-id-input {
  width: 140px !important;
}

.amount-input {
  width: 100px !important;
}

.count-select {
  width: 76px !important;
}

.quick-btn,
.partner-select,
.btn-search {
  height: 28px;
  border: 1px solid #047252;
  border-radius: 2px;
  background: transparent;
  color: #20de9a;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}

.quick-btn {
  min-width: 48px;
  padding: 0 10px;
}

.quick-btn.active {
  background: #13a667;
  border-color: #13a667;
  color: #fff;
}

.partner-select-wrap {
  position: relative;
}

.partner-select {
  min-width: 120px;
  padding: 0 10px;
  background: #2a285b;
  border-color: #2a285b;
  color: #fff;
}

.partner-tree-dropdown {
  position: absolute;
  top: 38px;
  right: 0;
  z-index: 30;
  width: 390px;
  max-height: 520px;
  overflow-y: auto;
  border: 1px solid #2c3a50;
  background: #172233;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.36);
}

.partner-tree-dropdown :deep(.subMemWrap) {
  width: 100%;
  box-shadow: none;
  border-radius: 0;
}

.partner-tree-dropdown :deep(.subPT_1) {
  min-height: 360px;
  padding: 18px 22px 20px;
  background: #172233;
}

.partner-tree-dropdown :deep(.subPT_1 h3) {
  margin-bottom: 12px;
  padding: 0;
  color: #dce6f3;
}

.btn-search {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  min-width: 34px;
  background: #2b70df;
  border-color: #2b70df;
  color: #fff;
}

.inline-check {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 6px;
  color: #dce6f3;
  font-size: 12px;
  white-space: nowrap;
}

.inline-check input {
  width: 14px !important;
  height: 14px !important;
  padding: 0 !important;
  cursor: pointer;
}

.memo-button {
  position: absolute;
  right: 12px;
  top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: 1px solid #2a3545;
  background: #202a38;
  opacity: 1;
}

.memo-button span {
  display: block;
  width: 34px;
  height: 34px;
  border: 2px solid #9da9bb;
  border-radius: 2px;
  position: relative;
}

.memo-button span::before,
.memo-button span::after {
  content: '';
  position: absolute;
  left: 6px;
  right: 6px;
  height: 2px;
  background: #9da9bb;
}

.memo-button span::before {
  top: 10px;
  box-shadow: 0 7px 0 #9da9bb;
}

.memo-button span::after {
  top: 24px;
}

.main-contents-wrapper {
  background: #0b1220;
}

.tab-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 3px solid #1d77e8;
}

.tab-item {
  width: 170px;
  height: 34px;
  border: 0;
  border-radius: 4px 4px 0 0;
  background: #28275a;
  color: #ffffff;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
}

.tab-item.active {
  background: #2677e8;
}

.table-wrapper {
  padding: 10px 10px 32px;
  background: #172233;
  border: 1px solid #223249;
  border-top: 0;
  overflow-x: auto;
}

.mainTable {
  width: 100%;
  min-width: 1460px;
  border-collapse: collapse;
  table-layout: fixed;
  color: #dce6f3;
}

.mainTable th,
.mainTable td {
  height: 42px;
  padding: 8px 10px;
  border: 1px solid #26364d;
  color: #dce6f3;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  vertical-align: middle;
}

.mainTable th {
  background: #223044;
  color: #ffffff;
  font-weight: 900;
}

.mainTable tbody tr {
  background: #172233;
}

.mainTable tbody tr:nth-child(2n) {
  background: #152033;
}

.mainTable tbody tr:hover {
  background: #1d2b42;
}

.btn-link {
  max-width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.fc-id {
  color: #7fb0ff;
  font-weight: 900;
}

.fc-btid {
  display: block;
  max-width: 155px;
  color: #71a6ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.game-kind,
.emptybet {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  min-height: 21px;
  padding: 2px 7px;
  border-radius: 3px;
  background: #2d3a52;
  color: #ffffff;
  font-size: 12px;
  font-weight: 800;
}

.emptybet.resultbet {
  background: #1969c9;
}

.emptybet.box-w {
  background: #6b58a6;
}

.emptybet.box-l {
  background: #9d3c49;
}

.emptybet.box-t {
  background: #56616f;
}

.e-bet .emptybet {
  outline: 1px solid #00b874;
}

.game-name,
.date-cell {
  word-break: break-all;
  white-space: normal;
}

.empty-cell {
  height: 80px;
  color: #93a0b3;
}

.roboto {
  font-family: Roboto, Arial, sans-serif;
}

.btnWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.copybtn {
  width: 18px;
  height: 18px;
  min-width: 18px;
  padding: 0;
  border: 0;
  background: url(~@/assets/img/icon_copy.svg) no-repeat center / contain;
  cursor: pointer;
  filter: invert(1);
  opacity: 0.8;
}

.red-text {
  color: #f06868 !important;
}

.blue-text {
  color: #7e89da !important;
}

.rdc {
  color: #f06868 !important;
}

.blc {
  color: #7e89da !important;
}

@media (max-width: 1000px) {
  .betting-history {
    min-width: 0;
    padding: 0 10px 30px;
  }

  .searchwrap {
    flex-direction: column;
    padding-right: 12px;
  }

  .memo-button {
    display: none;
  }

  .date-input-wrap,
  .filter-row {
    width: 100%;
  }

  .date-input-wrap input,
  .search-input,
  .bet-id-input,
  .amount-input,
  .count-select,
  .betting-history select {
    flex: 1 1 auto;
    width: auto !important;
  }

  .partner-select-wrap,
  .partner-select {
    flex: 1 1 auto;
  }

  .partner-select {
    width: 100%;
  }

  .partner-tree-dropdown {
    width: min(390px, 92vw);
  }
}
.modal-wrapper {
  justify-content: center;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  background: #0000006b;
  /*display: none;*/
  font-size: 12px;
  display: flex;
}
.modal-wrapper {
  display: flex;
}
.modal-wrap {
  padding: 0;
  width: 100%;
  height: 80%;
  overflow: auto;
  max-width: 1040px;
  min-width: 550px;
  z-index: 101;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-top: 0px;
  background: #fff;
  border-color: #fff;
}
.page-contents-wrap {
  padding: 0;
  background: #353535;
}
.sub-title {
  color: #121212;
  font-size: 14px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-bottom: 2px solid transparent;
}
.sub-title .btn {
  position: absolute;
  right: 15px;
  background: no-repeat;
  font-size: 22px;
  width: auto;
  height: auto;
  cursor: pointer;
}
.sub-title .btn img {vertical-align: middle;}
.page-content {
  padding: 27px 20px 25px;
  color: #121212;
  overflow: auto;
}
.page-content .content table {
  border: 1px solid #c9c9c9;
  width: 100%;
}
.page-content .content th, .page-content .content td {
  border: 1px solid #c9c9c9;
  padding: 15px;
  font-size: 13px;
}
.page-content .content p {
  font-size: 14px;
  text-align: left;
  margin: 10px 0;
}
.page-content .content p span {
  margin-left: 20px;
  display: block;
  border-radius: 18px;
  padding: 1px 12px;
}
.page-content .content p span.normal {
  background: #0f84ee;
}
.page-content .content p span.black {
  background: #808080;
}
.page-content .content p span.stop {
  background: #e1534e;
}
.page-content .content .setting {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 20px;
  text-align: center;
}
.page-content .content .setting em {
  font-size: 16px;
  display: block;
  margin-bottom: 10px;
}
.page-content .content .btnWrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
}
.page-content .content .btnWrap a {
  width: 168px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.page-content .content .btnWrap a.btn {
  border: 1px solid #a4a4a4;
  box-sizing: border-box;
  background: #545454;
}
.page-content .content .input {
  border: 1px solid #353535;
  font-size: 14px;
  width: 356px;
  height: 30px;
  margin-top: 20px;
}
.page-content .content .input::placeholder,
.page-content .content textarea::placeholder {
  color: #a4a4a4;
}
.page-content .content textarea {
  resize: none;
  width: 480px;
  height: 112px;
  padding: 10px 12px;
  font-size: 14px;
}
.modal-wrap .sub-title {
  border-color: #127c90;
}
.modal-wrap .sub-title .btn {
  color: #127c90;
  border: 0;
}
.modal-wrap .btnWrap a {
  background: #e1534e;
}
.resultWrap {
  margin-bottom: 20px;
}
.score {
  display: flex; gap: 5px; align-items: center;
}
.scoreL {
  justify-content: end;
}
.scoreN{
  padding: 3px 5px !important; border-radius: 4px !important; border: 1px solid #000; margin-left:0 !important;font-weight: bold;
}
.result-box-wrap {margin-top: 20px; display: flex; justify-content: center; gap: 20px; align-items: center;flex-direction: column;}
.result-box-wrap2 {margin-top: 20px; display: flex; justify-content: center; gap: 20px; align-items: center;}
.result-box {display: flex;align-items: center;justify-content: space-between;width: 75%;}
.scards {width: 100%;height: 35px; min-width: 22px;display: flex;background-size: contain;background-repeat: no-repeat;background-position: center;}
.cards {width: 100%;height: 83px; min-width: 60px;display: flex;background-size: contain;background-repeat: no-repeat;background-position: center;}

.c2C, .cc2 {background-image: url(~@/assets/img/card/c2.png);}
.c3C, .cc3 {background-image: url(~@/assets/img/card/c3.png);}
.c4C, .cc4 {background-image: url(~@/assets/img/card/c4.png);}
.c5C, .cc5 {background-image: url(~@/assets/img/card/c5.png);}
.c6C, .cc6 {background-image: url(~@/assets/img/card/c6.png);}
.c7C, .cc7 {background-image: url(~@/assets/img/card/c7.png);}
.c8C, .cc8 {background-image: url(~@/assets/img/card/c8.png);}
.c9C, .cc9 {background-image: url(~@/assets/img/card/c9.png);}
.cTC, .cct {background-image: url(~@/assets/img/card/c10.png);}
.cAC, .cca {background-image: url(~@/assets/img/card/ca.png);}
.cJC, .ccj {background-image: url(~@/assets/img/card/cj.png);}
.cKC, .cck {background-image: url(~@/assets/img/card/ck.png);}
.cQC, .ccq {background-image: url(~@/assets/img/card/cq.png);}

.c2D, .cd2 {background-image: url(~@/assets/img/card/d2.png);}
.c3D, .cd3 {background-image: url(~@/assets/img/card/d3.png);}
.c4D, .cd4 {background-image: url(~@/assets/img/card/d4.png);}
.c5D, .cd5 {background-image: url(~@/assets/img/card/d5.png);}
.c6D, .cd6 {background-image: url(~@/assets/img/card/d6.png);}
.c7D, .cd7 {background-image: url(~@/assets/img/card/d7.png);}
.c8D, .cd8 {background-image: url(~@/assets/img/card/d8.png);}
.c9D, .cd9 {background-image: url(~@/assets/img/card/d9.png);}
.cTD, .cdt {background-image: url(~@/assets/img/card/d10.png);}
.cAD, .cda {background-image: url(~@/assets/img/card/da.png);}
.cJD, .cdj {background-image: url(~@/assets/img/card/dj.png);}
.cKD, .cdk {background-image: url(~@/assets/img/card/dk.png);}
.cQD, .cdq {background-image: url(~@/assets/img/card/dq.png);}

.c2S, .cs2 {background-image: url(~@/assets/img/card/s2.png);}
.c3S, .cs3 {background-image: url(~@/assets/img/card/s3.png);}
.c4S, .cs4 {background-image: url(~@/assets/img/card/s4.png);}
.c5S, .cs5 {background-image: url(~@/assets/img/card/s5.png);}
.c6S, .cs6 {background-image: url(~@/assets/img/card/s6.png);}
.c7S, .cs7 {background-image: url(~@/assets/img/card/s7.png);}
.c8S, .cs8 {background-image: url(~@/assets/img/card/s8.png);}
.c9S, .cs9 {background-image: url(~@/assets/img/card/s9.png);}
.cTS, .cst {background-image: url(~@/assets/img/card/s10.png);}
.cAS, .csa {background-image: url(~@/assets/img/card/sa.png);}
.cJS, .csj {background-image: url(~@/assets/img/card/sj.png);}
.cKS, .csk {background-image: url(~@/assets/img/card/sk.png);}
.cQS, .csq {background-image: url(~@/assets/img/card/sq.png);}

.c2H, .ch2 {background-image: url(~@/assets/img/card/h2.png);}
.c3H, .ch3 {background-image: url(~@/assets/img/card/h3.png);}
.c4H, .ch4 {background-image: url(~@/assets/img/card/h4.png);}
.c5H, .ch5 {background-image: url(~@/assets/img/card/h5.png);}
.c6H, .ch6 {background-image: url(~@/assets/img/card/h6.png);}
.c7H, .ch7 {background-image: url(~@/assets/img/card/h7.png);}
.c8H, .ch8 {background-image: url(~@/assets/img/card/h8.png);}
.c9H, .ch9 {background-image: url(~@/assets/img/card/h9.png);}
.cTH, .cht {background-image: url(~@/assets/img/card/h10.png);}
.cAH, .cha {background-image: url(~@/assets/img/card/ha.png);}
.cJH, .chj {background-image: url(~@/assets/img/card/hj.png);}
.cKH, .chk {background-image: url(~@/assets/img/card/hk.png);}
.cQH, .chq {background-image: url(~@/assets/img/card/hq.png);}
@media (max-width: 767px) {
  .modal-wrap {
    width: calc(100% - 24px);
    min-width: 0;
    max-width: none;
    height: 85%;
  }

  .page-content {
    padding: 15px 10px;
  }

  .page-content .content {
    overflow-x: auto;
  }

  .result-box-wrap2 {
    flex-direction: column;
  }

  .result-box {
    width: 100%;
  }
}

.betting-history .searchwrap {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) 54px !important;
  grid-template-areas:
    "date memo"
    "filter memo" !important;
  align-items: center !important;
  gap: 10px 14px !important;
  min-height: 0 !important;
  padding: 18px 16px !important;
  overflow: visible !important;
}

.betting-history .searchwrap > .searchBar:nth-of-type(1) {
  grid-area: date !important;
}

.betting-history .searchwrap > .searchBar:nth-of-type(2) {
  grid-area: filter !important;
}

.betting-history .searchBar {
  width: 100% !important;
  min-width: 0 !important;
}

.betting-history .box-ui-select,
.betting-history .searchbar-content {
  width: 100% !important;
  min-width: 0 !important;
}

.betting-history .searchbar-content {
  display: grid !important;
  grid-template-columns: 82px minmax(0, 1fr) !important;
  align-items: center !important;
  gap: 8px 12px !important;
}

.betting-history .searchbar-content .title {
  width: 82px !important;
  min-width: 82px !important;
  height: 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  padding: 0 10px !important;
  border-right: 1px solid #e2e8f0 !important;
  color: #334155 !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  line-height: 1 !important;
  white-space: nowrap !important;
  box-sizing: border-box !important;
}

.betting-history .date-controls,
.betting-history .filter-row,
.betting-history .fx.date-controls {
  width: 100% !important;
  min-width: 0 !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
}

.betting-history .date-controls {
  flex-wrap: wrap !important;
}

.betting-history .filter-row {
  flex-wrap: nowrap !important;
}

.betting-history .date-input-wrap {
  flex: 0 0 auto !important;
  display: flex !important;
  align-items: center !important;
  gap: 6px !important;
  min-width: 0 !important;
}

.betting-history .date-input-wrap input {
  width: 158px !important;
  min-width: 158px !important;
  text-align: center !important;
}

.betting-history .date-separator {
  flex: 0 0 auto !important;
  width: 10px !important;
  text-align: center !important;
}

.betting-history .quick-btn {
  flex: 0 0 auto !important;
  min-width: 54px !important;
  padding: 0 10px !important;
  white-space: nowrap !important;
}

.betting-history .inline-check {
  flex: 0 0 auto !important;
  height: 31px !important;
  display: inline-flex !important;
  align-items: center !important;
  gap: 6px !important;
  margin: 0 0 0 6px !important;
  white-space: nowrap !important;
}

.betting-history .inline-check input {
  width: 14px !important;
  min-width: 14px !important;
  height: 14px !important;
  padding: 0 !important;
}

.betting-history .filter-row > select:first-child {
  flex: 0 0 140px !important;
  width: 140px !important;
}

.betting-history .filter-row .search-input {
  flex: 1 1 170px !important;
  min-width: 140px !important;
}

.betting-history .filter-row .bet-id-input {
  flex: 1 1 160px !important;
  min-width: 140px !important;
}

.betting-history .filter-row .amount-input {
  flex: 0 0 100px !important;
  width: 100px !important;
}

.betting-history .filter-row .count-select {
  flex: 0 0 88px !important;
  width: 88px !important;
}

.betting-history .partner-select-wrap {
  flex: 0 0 122px !important;
  width: 122px !important;
  height: 31px !important;
  margin: 0 !important;
  position: relative !important;
}

.betting-history .partner-select {
  width: 100% !important;
  height: 31px !important;
  padding: 0 8px !important;
  white-space: nowrap !important;
}

.betting-history .btn-search {
  flex: 0 0 38px !important;
  width: 38px !important;
  min-width: 38px !important;
  height: 31px !important;
  padding: 0 !important;
}

.betting-history .memo-button {
  grid-area: memo !important;
  position: static !important;
  justify-self: end !important;
  align-self: center !important;
  width: 52px !important;
  height: 52px !important;
  margin: 0 !important;
}

.betting-history .partner-tree-dropdown {
  top: 40px !important;
  left: auto !important;
  right: 0 !important;
  transform: none !important;
}

.betting-history .partner-tree-dropdown::before {
  left: auto !important;
  right: 54px !important;
  transform: rotate(45deg) !important;
}

@media (max-width: 1350px) {
  .betting-history .filter-row {
    flex-wrap: wrap !important;
  }

  .betting-history .filter-row .search-input,
  .betting-history .filter-row .bet-id-input {
    flex: 1 1 220px !important;
  }
}

@media (max-width: 1000px) {
  .betting-history .searchwrap {
    grid-template-columns: 1fr !important;
    grid-template-areas:
      "date"
      "filter" !important;
    padding: 14px !important;
  }

  .betting-history .memo-button {
    display: none !important;
  }

  .betting-history .searchbar-content {
    grid-template-columns: 1fr !important;
  }

  .betting-history .searchbar-content .title {
    width: 100% !important;
    min-width: 0 !important;
    justify-content: flex-start !important;
    border-right: 0 !important;
    border-bottom: 1px solid #e2e8f0 !important;
  }

  .betting-history .date-input-wrap,
  .betting-history .filter-row {
    flex-wrap: wrap !important;
  }

  .betting-history .date-input-wrap input,
  .betting-history .filter-row > select:first-child,
  .betting-history .filter-row .search-input,
  .betting-history .filter-row .bet-id-input,
  .betting-history .filter-row .amount-input,
  .betting-history .filter-row .count-select,
  .betting-history .partner-select-wrap,
  .betting-history .partner-select {
    flex: 1 1 calc(50% - 4px) !important;
    width: auto !important;
    min-width: 0 !important;
  }

  .betting-history .btn-search {
    flex: 1 1 100% !important;
    width: 100% !important;
  }
}

</style>
<style scoped src="@/styles/betWhite.css"></style>
